// PERF-001 Phase 3 (R1) — on-disk financial-PDF cache wipe (shared-device hardening).
//
// The service worker runtime-caches finalized invoice/estimate PDFs from the
// `documents` bucket on disk (CacheFirst). On a SHARED device a logged-out user
// could otherwise re-open a cached financial PDF, so logout must wipe it.
//
// DOCUMENT_CACHE_NAME MUST match the cacheName registered in
// src/service-worker.js — KEEP IN LOCKSTEP (separate bundle, can't import).
export const DOCUMENT_CACHE_NAME = 'crewvex-documents';

/**
 * Delete the on-disk Workbox cache of finalized document PDFs.
 * Fail-soft + guarded for environments without the Cache Storage API
 * (non-PWA browser, SSR, tests). Never throws.
 * @returns {Promise<boolean>} true if a cache was deleted, false otherwise.
 */
export async function wipeDocumentCache() {
  try {
    if (typeof caches === 'undefined' || typeof caches.delete !== 'function') return false;
    return await caches.delete(DOCUMENT_CACHE_NAME);
  } catch {
    return false;
  }
}
